// extracted by mini-css-extract-plugin
export var gif = "_cg-0";